/*
 * Build flag for the "Your referral code" cards on Profile (CANON V1.4 AMEND
 * REFERRALS-PER-BUYER-CODE; REFERRAL-BUILD-SPLIT-V1 §3). The section renders
 * ONLY when VITE_REFERRALS_ENABLED === 'true' — absent or anything else = OFF.
 * Stage sets it; prod leaves it absent until Duncan's prod GO. The env is
 * injectable so tests can pin both sides.
 */
export function referralsEnabled(env: Record<string, string | undefined> = import.meta.env): boolean {
  return env.VITE_REFERRALS_ENABLED === 'true'
}
